import { combineReducers } from '@reduxjs/toolkit';

import { accessTagsApi } from '~support-at-home/actions/accessTags';
import { accountCodesApi } from '~support-at-home/actions/accountCodes';
import { acoBudgetsApi } from '~support-at-home/actions/acoBudgets';
import { budgetsApi } from '~support-at-home/actions/budgets';
import { budgetExternalServicesApi } from '~support-at-home/actions/budgetServices';
import { budgetTrackerApi } from '~support-at-home/actions/budgetTracker';
import { dashboardBudgetsApi } from '~support-at-home/actions/dashboardBudgets';
import { dashboardBudgetsExpandedApi } from '~support-at-home/actions/dashboardBudgetsExpanded';
import { dashboardClaimItemsApi } from '~support-at-home/actions/dashboardClaimItems';
import { claimsApi } from '~support-at-home/actions/claims';
import { clientHcpUnspentFundsApi } from '~support-at-home/actions/clientHcpUnspentFunds';
import { clientInvoicesApi } from '~support-at-home/actions/clientInvoices';
import { companyShiftsApi } from '~support-at-home/actions/companyShifts';
import { packageSchedulesApi } from '~support-at-home/actions/packageSchedules';
import { prodaConnectionApi } from '~support-at-home/actions/prodaConnection';
import { reconciliationsApi } from '~support-at-home/actions/reconciliations';
import { sahReferenceDataApi } from '~support-at-home/actions/sahReferenceData';
import { sahServiceTypeAssociationsApi } from '~support-at-home/actions/sahServiceTypeAssociations';
import { statementBudgetsSummaryApi } from '~support-at-home/actions/statementBudgetsSummary';
import { statementsApi } from '~support-at-home/actions/statements';
import { supplierInvoicesApi } from '~support-at-home/actions/supplierInvoices';
import { sahReportsApi } from '~support-at-home/actions/sahReports';
import { userTagsApi } from '~support-at-home/actions/userTags';
import budgetServices from './budgetServices';
import clientBudgetStatuses from './clientBudgetStatuses';
import clientContributions from './clientContributions';
import clientServices from './clientServices';
import clientsWithBudgets from './clientsWithBudgets';
import externalApiStatuses from './externalApiStatuses';
import fundingTypes from './fundingTypes';
import pricePlanRevisions from './pricePlanRevisions';
import pricePlans from './pricePlans';
import sahBudgets from './sahBudgets';
import sahServiceTypeAssociations from './sahServiceTypeAssociations';
import supplierInvoices from './supplierInvoices';
import suppliers from './suppliers';

export const supportAtHome = {
  budgetServices,
  clientBudgetStatuses,
  clientContributions,
  clientServices,
  externalApiStatuses,
  pricePlanRevisions,
  pricePlans,
  sahBudgets,
  sahServiceTypeAssociations,
  supplierInvoices,
  suppliers,
  clientsWithBudgets,
  fundingTypes,
};

export default combineReducers(supportAtHome);

export const supportAtHomeApis = [
  accessTagsApi,
  accountCodesApi,
  budgetExternalServicesApi,
  budgetsApi,
  budgetTrackerApi,
  dashboardBudgetsApi,
  dashboardBudgetsExpandedApi,
  dashboardClaimItemsApi,
  claimsApi,
  clientInvoicesApi,
  clientHcpUnspentFundsApi,
  companyShiftsApi,
  packageSchedulesApi,
  prodaConnectionApi,
  reconciliationsApi,
  acoBudgetsApi,
  sahReferenceDataApi,
  sahServiceTypeAssociationsApi,
  statementBudgetsSummaryApi,
  statementsApi,
  supplierInvoicesApi,
  sahReportsApi,
  userTagsApi,
] as const;
